import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import { ISO_FORMAT } from "../DatePicker/constants";
import { determineLastFinancialYear, determineThisFinancialYear } from "./helpers/determineFinancialYear";
dayjs.extend(quarterOfYear);
var time = dayjs();
var PRESET_OPTIONS = [{
  key: "today",
  label: "Today",
  from: time.startOf("day").format(ISO_FORMAT),
  to: time.endOf("day").format(ISO_FORMAT)
}, {
  key: "yesterday",
  label: "Yesterday",
  from: time.subtract({
    day: 1
  }).startOf("day").format(ISO_FORMAT),
  to: time.subtract({
    day: 1
  }).endOf("day").format(ISO_FORMAT)
}, {
  key: "this_week",
  label: "This week",
  from: time.startOf("week").format(ISO_FORMAT),
  to: time.endOf("week").format(ISO_FORMAT)
}, {
  key: "last_week",
  label: "Last week",
  from: time.subtract({
    week: 1
  }).startOf("week").format(ISO_FORMAT),
  to: time.subtract({
    week: 1
  }).endOf("week").format(ISO_FORMAT)
}, {
  key: "this_month",
  label: "This month",
  from: time.startOf("month").format(ISO_FORMAT),
  to: time.endOf("month").format(ISO_FORMAT)
}, {
  key: "last_month",
  label: "Last month",
  from: time.subtract({
    month: 1
  }).startOf("month").format(ISO_FORMAT),
  to: time.subtract({
    month: 1
  }).endOf("month").format(ISO_FORMAT)
}, {
  key: "this_quarter",
  label: "This quarter",
  from: time.startOf("quarter").format(ISO_FORMAT),
  to: time.endOf("quarter").format(ISO_FORMAT)
}, {
  key: "last_quarter",
  label: "Last quarter",
  from: time.subtract({
    quarter: 1
  }).startOf("quarter").format(ISO_FORMAT),
  to: time.subtract({
    quarter: 1
  }).endOf("quarter").format(ISO_FORMAT)
}, {
  key: "past_12_months",
  label: "Past 12 months",
  from: time.subtract({
    month: 12
  }).format(ISO_FORMAT),
  to: time.format(ISO_FORMAT)
}, {
  key: "past_24_months",
  label: "Past 24 months",
  from: time.subtract({
    month: 24
  }).format(ISO_FORMAT),
  to: time.format(ISO_FORMAT)
}, {
  key: "this_financial_year",
  label: "This financial year",
  from: determineThisFinancialYear("from"),
  to: determineThisFinancialYear("to")
}, {
  key: "last_financial_year",
  label: "Last financial year",
  from: determineLastFinancialYear("from"),
  to: determineLastFinancialYear("to")
}];
export default PRESET_OPTIONS;